import React from 'react';
import Head from 'next/head';

import { useAppConfigStateContext } from '@edx/contexts/app-config';
import { ResponsiveImage } from '@edx/types/responsive-image';
import { Hero } from '@edx/components/hero';
import { SubscriptionGiftForm } from '@edx/components/subscription-gift-form';
import { HowItWorks } from '@edx/components/landing/components/how-it-works';
import { Body, Intro } from '@edx/components/typography';
import { route } from '@edx/helpers/url';
import { ZendeskWidget } from '@edx/components/zendesk-widget';

type Props = {
  bgImage: ResponsiveImage;
};

const GiftPage: React.FC<Props> = ({ bgImage }) => {
  const { projectName, projectShortName } = useAppConfigStateContext();

  return (
    <>
      <Head>
        <title key="title">Regala {projectShortName}</title>

        <meta
          key="description"
          name="description"
          content={`Elije uno de nuestros planes y regala a tus amigos una suscripción a ${projectName}.`}
        />

        <link rel="canonical" href={route(`/regala-${projectShortName.toLowerCase()}`)} />

        <script
          src="https://js.chargebee.com/v2/chargebee.js"
          data-cb-site={process.env.NEXT_PUBLIC_EDX_CHARGEBEE_SITE}
        />
      </Head>

      <Hero
        preheading="· Estas navidades ·"
        heading={`Regala ${projectShortName}`}
        bgImage={bgImage}
        contentClassName="-mt-10vh"
        variant="small"
      />

      <section className="flex flex-col items-center max-w-3xl mx-auto mb-16 px-4 sm:px-8">
        <Intro
          tag="h2"
          size="small"
          className="sm:text-intro text-gray-400 text-center py-8 border-t border-b border-gray-600 border-opacity-50"
        >
          Regala una suscripción trimestral o anual a {projectName} y dale a quien tú quieras el empujón que necesita
          para aprender a tocar el bajo
        </Intro>

        <Body size="large" className="text-gray-500 text-center py-6">
          Elige cuándo quieres que lo reciba y añade un mensaje. El alumno recibirá en su email el acceso para empezar.
        </Body>

        <SubscriptionGiftForm />
      </section>

      <HowItWorks />

      <ZendeskWidget />
    </>
  );
};

export default GiftPage;
